/* ============
 * State of the auth module
 * ============
 *
 * The initial state of the auth module.
 */

export default {
  myCustomers: {},
  myProjects: {},
  myBrokers: {},
  brokerListWithDrm: [],
};



// WEBPACK FOOTER //
// ./src/store/modules/saleshead/state.js